<div class="setting-item" [class]="designClass">
  <div class="col-left">
    <div class="title">{{ title }}</div>
    <div class="description" *ngIf="description">{{ description }}</div>
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</div>
